import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import PromoCards from './components/promo-cards';
import { withCommon, LLPreloader, LLTextSlider } from '../../components';

/**
 * @file Represents Promo page to render the list of available bonuses
 *
 * @param {function} getPromos - action that set list of available bonuses
 *
 * @author I.Mykhailychenko
 */

const PromoPage = withCommon({
    store: ({ store }) => ({
        getPromos: store.promos.getPromos,
        categories: store.promos.categories,
        isLogged: store.user.isLogged,
        viewSize: store.site.status.viewSize,
    }),
    propTypes: {
        getPromos: PropTypes.func.isRequired,
    },
    defaultName: 'PromoPage',
    isObserver: true,
    isTrans: true,
})(({ trans, getPromos, categories, isLogged, viewSize }) => {
    const [loading, setLoading] = useState(true);
    const [activeTab, setActiveTab] = useState('All');

    useEffect(() => {
        getPromos().then(() => {
            setLoading(false);
        });
    }, [isLogged]);

    return (
        <section className="ll-page promo-content">
            {loading ? (
                <div className="promo-content__loader">
                    <LLPreloader />
                </div>
            ) : (
                <>
                    {categories.length > 1 ? (
                        <LLTextSlider
                            id="promo-content__categories"
                            viewSize={viewSize}
                            customClasses={{
                                slider: 'promo-content__categories',
                            }}
                            activeItem={activeTab}
                        >
                            {categories.map((cat) => (
                                <div
                                    id={cat.id}
                                    key={cat.id}
                                    className={cx('promo-content__category', activeTab === cat.id ? 'active' : null)}
                                    onClick={() => {
                                        setActiveTab(cat.id);
                                    }}
                                >
                                    <span>{cat.name ?? trans(cat.id)}</span>
                                </div>
                            ))}
                        </LLTextSlider>
                    ) : null}
                    <PromoCards activeTab={activeTab} />
                </>
            )}
        </section>
    );
});

export default PromoPage;
